import { render, staticRenderFns } from "./MembershipDetails.vue?vue&type=template&id=036bfa78&"
import script from "./MembershipDetails.vue?vue&type=script&lang=ts&"
export * from "./MembershipDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports